import React from 'react';

import Guest from 'app/components/icons/Guest';
import ReservationDetail, {
  ReservationDetailProps,
} from 'app/components/ReservationSummary/ReservationDetail';
import TextLabel from 'app/components/ReservationSummary/TextLabel';
import { useI18n } from 'app/providers/I18nProvider';
import { Pass, TicketClass } from 'app/services/GuestCenterService.types';

export type ReservationDetailTravelPartyProps = Omit<ReservationDetailProps, 'Icon'> & {
  passes: Pass[];
};

function ReservationDetailTravelParty({
  passes = [],
  ...props
}: ReservationDetailTravelPartyProps) {
  const { t } = useI18n();
  const qty = passes.reduce<Record<TicketClass, number>>(
    (prev, pass) => {
      /* eslint-disable no-param-reassign */
      prev[pass.ticketClass] += 1;
      /* eslint-enable no-param-reassign */
      return prev;
    },
    {
      [TicketClass.Adult]: 0,
      [TicketClass.Child]: 0,
    }
  );

  return (
    <ReservationDetail Icon={Guest} testID="ReservationDetailTravelParty" {...props}>
      <TextLabel>{qty.Adult > 0 && `${t('gen_adult')} (${qty.Adult})`}</TextLabel>
      <TextLabel>{qty.Child > 0 && `${t('gen_child')} (${qty.Child})`}</TextLabel>
    </ReservationDetail>
  );
}

ReservationDetailTravelParty.Icon = Guest;

export default ReservationDetailTravelParty;
